import { combineRules } from 'fela'; // eslint-disable-line behance/no-deprecated

import { ThemeProvider, connect, withTheme as _withTheme } from 'react-fela'; // eslint-disable-line behance/no-deprecated

import applyStaticStyles from './applyStaticStyles';
import applyTheme from './applyTheme';
import createComponent from './createComponent';
import createComponentStyles from './createComponentStyles';
import createStyledComponent from './createStyledComponent';
import withRenderer from './withRenderer';
import { isValidElementProp, filterValidElementProps } from './isValidElementProp';
export * from './types';
export var withTheme = _withTheme;
export { createComponent, applyTheme, ThemeProvider, connect, combineRules, createComponentStyles, withRenderer, applyStaticStyles, createStyledComponent, isValidElementProp, filterValidElementProps };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/es/index.js
// module id = 1066
// module chunks = 0